import {
  Body,
  Button,
  Controller,
  Group,
  Stack,
  useFormContext,
} from '@qred/components-library';
import React from 'react';
import useTranslate from '~/hooks/useTranslate';
import { useSelector } from 'react-redux';
import { RootState } from '~/store';
import { StartApplicationForm } from '../StartApplication.schema';

export const ForeignCurrencyIncome = () => {
  const { control } = useFormContext<StartApplicationForm>();
  const t = useTranslate();
  const {
    matchedMedia: { mobile },
  } = useSelector((state: RootState) => state);

  return (
    <Stack spacing="lg">
      <Body size="lg">{t('Onboarding.TurnoverForeignCurrencyQuestion')}</Body>
      <Group direction="row">
        <Controller
          control={control}
          name="incomeReceivedInForeignCurrencies"
          render={({ field }) => (
            <>
              <Button
                data-active={field.value === true}
                onClick={() => {
                  field.onChange(true);
                }}
                size="md"
                variant="secondary"
                data-cy="foreign_currency_question_button"
                style={{ flexGrow: mobile ? 1 : 0 }}
              >
                {t('Yes')}
              </Button>
              <Button
                data-active={field.value === false}
                onClick={() => {
                  field.onChange(false);
                }}
                size="md"
                variant="secondary"
                data-cy="foreign_currency_question_button"
                style={{ flexGrow: mobile ? 1 : 0 }}
              >
                {t('No')}
              </Button>
            </>
          )}
        />
      </Group>
    </Stack>
  );
};
